import React, { useEffect, useState } from 'react';
import Button from '$/components/base/Button';
import { Modal, Switch } from 'antd';
import cookieUtils from 'js-cookie';
import styles from './index.module.scss';

const cookiePolicyHref = 'https://h5.starii.com/vmake-h5/agreements/privacy-policy.html#cookies';

const COOKIE_POLICY = 'COOKIE_POLICY';
/**
 * cookie 策略
 */
enum CookiePolicy {
  /**
   * 拒绝
   */
  REJECT = '0',

  /**
   * 接受
   */
  ACCEPT = '1',
}
function clearOptionCookies() {
  const optionCookiesToClear: { name: string; }[] = [{ name: '_sm' }, { name: 'meitustat' }];

  optionCookiesToClear.forEach((cookie) => {
    const { name, ...restCookie } = cookie;
    if (cookieUtils.get(name)) {
      cookieUtils.remove(name, restCookie);
    }
  });
}

function CookieBanner() {
  const [local, setLocal] = useState({
    isFold: true,
    isModalOpen: false,
    collapsed: true,
    isCookieConsentGiven: true,
    enabled: true,
  });

  const updateLocal = (newValues: Partial<typeof local>) => {
    setLocal((prev) => ({ ...prev, ...newValues }));
  };

  const handleShowModal = () => {
    updateLocal({ isModalOpen: true });
  };

  const handleOk = () => {
    updateLocal({ isModalOpen: false });

    handleAccept();
  };

  const handleCancel = () => {
    updateLocal({ isModalOpen: false });
  };

  const handleAccept = () => {
    updateLocal({ isCookieConsentGiven: true });
    cookieUtils.set(COOKIE_POLICY, CookiePolicy.ACCEPT, {
      expires: 180,
    });
    if (!local.enabled) {
      clearOptionCookies();
      // window.location.reload();
    }
  };
  const renderModalContent = () => (
    <div className={styles.columnFlexContainer}>
      <div className={styles.columnFlexSubContainer}>
        <div className={styles.title}>Cookies Preferences</div>
        <div className={styles.desc}>
          Cookies and similar technologies collect certain information about how you are using our website. This information might be about you, your preferences or your device and is mostly used to make the site work seamlessly. We respect your right to privacy, you can choose not to allow some cookies. However, blocking some cookies may impact your experience of our website and our services we are able to offer.  For more information about our use of cookies, please click to learn more.
        </div>
      </div>
      <div className={styles.columnFlexSubContainer}>
        <div className={styles.title}>Manage Consent Preferences</div>
      </div>
      <div className={styles.columnFlexSubContainer}>
        <div className={`${styles.title} ${styles.titleBox}`}>
          <span className={styles.switchTitle}>Essential Cookies</span>
          {local.enabled ? (<div className={styles.switchTip}>Active</div>) : null}
          <Switch
            defaultChecked={local.enabled}
            onChange={(value) => {
              updateLocal({ enabled: value });
            }}
            style={{
              backgroundColor: 'var(--background-fillAccent, #704DFF)',
              boxShadow: 'none',
            }}
          />
        </div>
        <div className={styles.desc}>
          These essential cookies are necessary for our website to function. They are usually only set in response to actions made by you which amount to a request for our services. You can set your browser to block these cookies, but some parts of our website will not display properly. These cookies do not store any personally identifiable information.
        </div>
      </div>
      <div className={styles.buttonBox}>
        <Button
          type="primary"
          buttonStyle={{
            fontSize: '15px',
            height: '40px',
            width: '170px',
          }}
          onClick={handleOk}
        >
          Confirm My Choices
        </Button>
      </div>
    </div>
  );
  useEffect(() => {
    const cookiePolicy = cookieUtils.get(COOKIE_POLICY);
    updateLocal({ isCookieConsentGiven: !!cookiePolicy });

    if (!cookiePolicy) {
      // logSVEvent('cookie_popup_exposure');
    }
    if (cookiePolicy === CookiePolicy.REJECT) {
      clearOptionCookies();
    }
  }, []);
  return local.isCookieConsentGiven ? null : (
    <div>
      <div
        className={`${styles.cookies} ${local.isModalOpen ? styles.hide : ''} ${local.collapsed ? styles.collapsed : ''}`}
      >
        <div className={styles.innerContent}>
          <div>
            <div className={styles.title}>
              Please set your cookie preferences
            </div>
            <div className={styles.desc}>
              Welcome to RoboNeo! We would like to use cookies on the website to ensure the security, efficient operation and service optimization of the website. For more information about our use of cookies, please
              <a href={cookiePolicyHref} target="_blank" rel="noreferrer">
                click
              </a>
              to learn more.
            </div>
          </div>
          <div className={styles.btns}>
            <Button
              className={`${styles.btnItem} ${styles.btnLeftItem}`}
              onClick={handleAccept}
              type="primary"
            >
              Accept Cookies
            </Button>
            <Button
              className={`${styles.btnItem}`}
              onClick={handleShowModal}
            >
              Manage Cookies
            </Button>
          </div>
        </div>
      </div>

      <Modal
        title={null}
        open={local.isModalOpen}
        centered
        onCancel={handleCancel}
        modalRender={renderModalContent}
        width={480}
      />
    </div>
  );
}
export default CookieBanner;
